export default "6621322941f64d09.svg"